<template>
  <div class="qanda drawer-detail" style="padding-top:20px;">
    <!-- <div class="field-type">
      <span class="label">可能的问题及应对:</span>
    </div> -->
    <template v-if="showQA.length>0">
      <div v-for="(obj,ind) in showQA" :key="`QA${ind}`" class="field-type">
        <pre class="value company-pre">Q:{{obj.Q}}
A:{{obj.A}}</pre>
      </div>
    </template>
    <template v-else>
      <div class="field-type">
        <div class="gray-text value company-pre">
          <p>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['可能的问题及应对'],
      translateTag:{},
    }
  },
  computed: {
    showQA() {
      const arr = (this.company['可能的问题及应对'] || []).filter(v=>v.Q||v.A)
      return arr
    },
  },
  methods: {
    quickEdit(){
      const field = '可能的问题及应对'
      const { translateTag, company } = this
      this.$emit('quickEdit',{
        value: company[field],
        label:translateTag[field]||field,
        type:'question',
        confirmFunc:async(v)=>{
          const res = await app.service('company').modifyCompany({
            query: { _id: this.company._id },
            data: { [field]: v },
          })
          if (res.status === 'success' || res.status === 200) {
            this.$set(this.company,field,v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.cognize-box{
  display: flex;
  flex-wrap:wrap;
}
.cognize-box span{
  display: inline-block;
  min-width: 50%;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
.qanda .field-type .value::after {
  border-bottom-color: transparent;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
